// Centralised module definitions used across UnitDetailScreen, SquadScreen
export const MODULE_LIST = [
    { id: "armor_plate", name: "Armor Plate", icon: "🔩", desc: "+20 HP" },
    { id: "overclock_chip", name: "Overclock Chip", icon: "⚙️", desc: "+4 ATK" },
    { id: "shield_matrix", name: "Shield Matrix", icon: "🛡", desc: "+3 DEF" },
    { id: "velocity_core", name: "Velocity Core", icon: "💨", desc: "+3 SPD" },
    { id: "repair_kit", name: "Repair Kit", icon: "🔧", desc: "+8 Skill Power" },
    { id: "crit_amplifier", name: "Crit Amplifier", icon: "🎯", desc: "Crits deal ×2 instead of ×1.5" },
];
export const MODULE_BY_ID = Object.fromEntries(MODULE_LIST.map(m => [m.id, m]));
// Icon-only map for compact display (e.g. squad slot badges)
export const MODULE_ICON = Object.fromEntries(MODULE_LIST.map(m => [m.id, m.icon]));
